import { PipeTransformPipe } from './../../../shared/pipe/pipe-transform.pipe';
import { LanguageSelector, defaultLanguage, tutorialVideo } from './../../constant';
import { HttpClientService } from './../../../shared/services/http-client.service';
import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params, Event as NavigationEvent, RoutesRecognized, NavigationEnd } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage';

import { CookieNames, BasicRoutes, ApiEndpoints } from '../../constant';
import { CookieManagerService, CustomObserverService, ShoppingCartService, LoginRedirectService, ErrorManagerService } from '../../../shared/';
import { CookieService } from 'ngx-cookie-service';

import { ItemsCheckout } from '../../model/itemsCheckout';
import { CommonService } from '../../../shared/services/common-service';
import { Competition } from '../../model';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';


declare var $: any;

@Component({
  selector: 'app-main',
  templateUrl: '../views/main.component.html',
  styleUrls: ['../views/landing.component.css'],
})
export class MainComponent implements OnInit {
  public value: string;

  public username: Object;
  public user: any;
  private cartItemsArray: Array<ItemsCheckout>;
  public totalPrice: number = 0;
  public itemLength: number = 0;
  public loginModal;
  public isOpen: boolean = false;
  public navIsFixed: boolean = false;
  public isMenuHide: boolean = false;
  public isMenuHideBackButton: boolean = true;
  public backHide: boolean = false;
  public paymentType: any;
  public currentPaymentType: string;
  public hotline: string;
  public aboutUs: any;
  public languages = LanguageSelector;
  public languagesCount = 1;
  public selectedLanguage: string;
  public setCollectionTips: string;
  public isPromo: boolean = false;
  public isShow: boolean = true;
  public tutorial = tutorialVideo;
  public tutorialUrl;
  public showVideo = false;


  competition: any;
  constructor(
    private customObserverService: CustomObserverService,
    private cookieManagerService: CookieManagerService,
    private localStorageService: LocalStorageService,
    private shoppingCartService: ShoppingCartService,
    private loginRedirectService: LoginRedirectService,
    private translateService: TranslateService,
    private router: Router,
    private httpClientService: HttpClientService,
    private cookieService: CookieService,
    private commonService: CommonService,
    private pipeTransform: PipeTransformPipe,
    private ErrorManagerService: ErrorManagerService,
    @Inject(DOCUMENT) private document: Document
  ) {

    this.customObserverService.missionAnnounced$.subscribe(value => {
      let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
      this.user = userObj ? JSON.parse(userObj.toString()) : null;
      if (this.user) {
        this.user.image = value;
      }
    });
    this.customObserverService.name$.subscribe(value => {
      this.username = value;
    });

    this.customObserverService.paymentCode$.subscribe(value => {
      this.isMenuHide = value;
      this.backHide = !value;
    });

    this.customObserverService.registrationFee$.subscribe(value => {
      this.backHide = value;
    });

    this.shoppingCartService.getItemsLength()
      .subscribe(res => {
        if (res != null) {
          this.isOpen = $("#hu").is(":visible");
          let oldItemLength = this.itemLength;
          this.getCartItems();
          this.itemLength = res.length;
          if (!this.isOpen) {
            this.swingCart();
          }
          if (this.itemLength > oldItemLength) {
            if (this.itemLength > 1 && this.isOpen) {
              this.shoppingCartService.resetTimer();
            }
          }
        }
      });
    this.getCartItems();
    //// Side pop up
    let that = this;
    this.customObserverService.alert$.subscribe((value: any) => {
      this.isShow = value.isShow;
      this.isPromo = !value.isShow;
      if (!value.isShow && document.getElementById('news-section')) {
        document.getElementById('news-section').style.display = 'none';
      }
      else if (!value.isOnGoing && value.isShow) {
        document.getElementById('news-section').style.display = 'block';
      }
    });
    /////// side pop up
  }

  ngOnInit() {


    this.fetchcompetitions();
    if (this.isShow) {
      this.newsTips(); // comment becuase of giving error when not log in
    }

    // this.newsTips(); 
    this.languagesCount = this.languages.length;
    var language = this.cookieManagerService.getCookie("Lang", false);
    this.selectedLanguage = language ? language : defaultLanguage;


    if (this.cookieManagerService.getCookie("isComPopupClosed", false) != "true") {
      // $('#competitionPopup').modal('show');
    }

    if (this.tutorial && this.tutorial.show && this.cookieManagerService.getCookie("isPopupClosed", false) !== "true") {
      this.tutorialUrl = this.pipeTransform.transform(this.tutorial.videoUrl);
      let innerWidth = window.innerWidth;

      if (innerWidth > 768) {
        $('#infoPopup').modal('show');
      }
    };
    if (this.router.url == BasicRoutes.registrationPayment) {
      //to hide the menue
      this.isMenuHide = true;
      //to hide back button once menue hide
      this.isMenuHideBackButton = false;
    }
    this.paymentType = this.localStorageService.get("PAYMENT_TYPES");
    if (this.paymentType == null) {
      this.getPaymentTypes();
    }
    this.loginRedirectService.setRedirectPoint("registration");
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
    this.user = userObj ? JSON.parse(userObj.toString()) : null;
    if (this.user) {
      this.user.image = this.localStorageService.get(CookieNames.userImage);
      if (this.user.firstname) {
        this.username = this.user.firstname;
      } else {
        this.username = this.user.username;
      }
    }
    this.cartItemsArray = this.shoppingCartService.allStorage();
    this.itemLength = this.shoppingCartService.itemsIDArray.length;
    this.aboutUs = this.localStorageService.get("ABOUTUS");
    this.getPartners();
  }

  getPaymentTypes() {
    this.httpClientService.get(ApiEndpoints.getPaymentTypes).subscribe(
      response => {
        if (response && response.paymentType) {
          this.localStorageService.set("PAYMENT_TYPES", response.paymentType);
        }
      }, error => {

      });
  }

  closeInfoPopup() {
    this.cookieManagerService.setCookie("isPopupClosed", "true", false, 0.5);
  }

  ngAfterViewInit() {
    this.loginModal = $('#log-in-pop');
    this.totalPrice = this.shoppingCartService.returnTotalPrice();
    let _that = this;
    $('body').click(function (evt) {
      if (!(($(evt.target).closest('#hu').length) || ($(evt.target).closest('#bag').length) || ($(evt.target).closest('#cart-wrap').length) || ($(evt.target).closest('#pointer').length) || ($(evt.target).closest('#yes-button').length))) {
        _that.isOpen = $("#hu").is(":visible");
        if (_that.isOpen) {
          $("#hu").hide();
          _that.shoppingCartService.clearTimer();
          _that.isOpen = false;
          return;
        }
      }
    });
  }

  /**
   * Logout grom the application
   * edit
   * kaushalya
   * 2017-10-26
   * set path to remove the cookies
   */
  logout() {
    this.cookieService.delete(CookieNames.loginKey, '/');
    this.cookieService.delete(CookieNames.userobj, '/');
    this.cookieService.deleteAll('/');
    this.username = null;

    // if (this.cookieService.delete(CookieNames.userobj)) {
    //   this.cookieService.delete(CookieNames.userobj);
    // }
    this.localStorageService.clearAll();
    this.shoppingCartService.clearPersonelItems();
    this.localStorageService.remove(CookieNames.userImage);
    this.cookieManagerService.removeCookie(CookieNames.isRemoveCartItem, '/');
    // this.router.navigate([BasicRoutes.loginRedirect]);
  }

  getCartItems() {
    this.shoppingCartService.itemsCheckout.subscribe((response) => {
      this.cartItemsArray = response;
      this.totalPrice = this.shoppingCartService.returnTotalPrice();
    });
  }

  getPartners() {

    this.commonService.getPartners().then((response: any) => {
      this.aboutUs = response;
      this.hotline = this.aboutUs ? this.aboutUs.contact : null;
    });
  }

  removeItemCheckout(item_id) {
    this.customObserverService.setItemStatus(item_id);
    this.shoppingCartService.removeItemsCheckout(item_id);
    this.getCartItems();
  }

  clickOn() {
    this.isOpen = $("#hu").is(":visible");
    if (this.isOpen) {
      $("#hu").hide();
    } else {
      $("#hu").show();
    }
  }
  swingCart() {
    $('#bag .cart-bag').addClass('rotate').delay(1000).queue(function (next) {
      $(this).removeClass('rotate');
      next();
    })
  }

  backToMobile() {
    window.open(ApiEndpoints.MOBILE_REDIRECT_URL);
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number > 100) {
      this.navIsFixed = true;
    } else if (this.navIsFixed && number < 10) {
      this.navIsFixed = false;
    }
  }

  public livePaperSetCount = 0;
  getLivePaperSetCount() {
    var url = ApiEndpoints.getOnlinePaperSets;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(url, { [ApiEndpoints.paperType]: 'ONLINE_EXAM', [ApiEndpoints.pageNumber]: 1, [ApiEndpoints.paperUserStatus]: 'undefined' }), null).subscribe(
      res => {
        if ((res.papersets || false)) {
          this.livePaperSetCount = res.papersets.length === 0 ? this.livePaperSetCount : res.count;
          if (this.livePaperSetCount > 0) {
            this.router.navigate(['home/exams/online']);
          }
          else {
            this.router.navigate(['home/exams']);
          }
        }
        else {
          this.router.navigate(['home/exams']);
        }
      }, e => {
      });
  }

  changeLanguage(value) {
    this.selectedLanguage = value;
    this.cookieManagerService.setCookie("Lang", value);
    var language = this.cookieManagerService.getCookie("Lang", false);
    this.translateService.use(language ? language : defaultLanguage);
    this.customObserverService.setCurrentLanguage(value);
    // $('#infoPopup').modal('show');

  }

  fetchComp(): Observable<any> {
    // tslint:disable-next-line: prefer-const
    let language = this.cookieManagerService.getCookie('Lang', false);
    return this.httpClientService.get(environment.ENV.apiBaseUrl + 'admin/competition/' + (language ? language : defaultLanguage));
  }
  fetchcompetitions() {
    this.fetchComp().subscribe(
      competitions => {
        console.log(competitions);
        if (competitions !== 'null') {

          this.competition = competitions;
          // tslint:disable-next-line: no-unused-expression
          this.competition ? $('#competitionPopup').modal('show') : '';

        }


      }, error => {
        console.log(error);
        this.ErrorManagerService.setError(error);
      });
  }

  newsTips() {
    this.httpClientService.get(ApiEndpoints.offerImage).subscribe(response => {
      if (Object.keys(response).length != 0) {
        this.setCollectionTips = response.description;
        this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: true });

      } else {
        this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: false });
      }
    }, error => {
      this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: false });
    });
  }

  closeNews() {
    this.isPromo = true;
    this.customObserverService.hideNewsAlert({ isOnGoing: false, isShow: false });
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/components/main.component.ts